<template>
  <el-card
    class="settings"
    shadow="never">
    <div
      slot="header"
      class="settings-header">
      标签栏设置
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="140px">
      <el-form-item
        label="标题选中颜色："
        prop="tabBarNameCheckedColour">
        <el-color-picker v-model="form.tabBarNameCheckedColour"></el-color-picker>
      </el-form-item>
      <el-form-item
        label="标题未选中颜色："
        prop="tabBarNameUncheckedColour">
        <el-color-picker v-model="form.tabBarNameUncheckedColour"></el-color-picker>
      </el-form-item>
      <el-form-item
        label="tabBar样式："
        prop="tabBarCustoms">
        <el-tabs
          v-model="activeName">
          <el-tab-pane
            v-for="(item, index) in form.tabBarCustoms"
            :key="item.tabBarId"
            :label="item.tabBarName"
            :name="item.tabBarId + ''">
            <el-form-item
              label="选中图标："
              label-width="120px"
              :prop="'tabBarCustoms.' + index + '.checkedImage'"
              :rules="[{ required: true, message: '请上传选中图标', trigger: 'change' }]">
              <upload-with-crop
                v-model="form.tabBarCustoms[index].checkedImage"
                :showTip="false"
                :limit="1"
                :maxSize="50"
                maxSizeName="50kb"
                :cropper="true"
                :fixedNumber="[1,1]"
                :autoCropWidth="80"
                :autoCropHeight="80" />
            </el-form-item>
            <el-form-item
              label="未选中图标："
              label-width="120px"
              :prop="'tabBarCustoms.' + index + '.uncheckedImage'"
              :rules="[{ required: true, message: '请上传未选中图标', trigger: 'change' }]">
              <upload-with-crop
                v-model="form.tabBarCustoms[index].uncheckedImage"
                :showTip="false"
                :limit="1"
                :maxSize="50"
                maxSizeName="50kb"
                :cropper="true"
                :fixedNumber="[1,1]"
                :autoCropWidth="80"
                :autoCropHeight="80" />
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <el-alert
        title="只能上传image/*文件，且不超过50kb，宽高比例为1：1。"
        :closable="false"
        type="warning">
      </el-alert>
    </el-form>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
import UploadWithCrop from '@/components/wx/upload-with-crop.vue'
export default {
  name: 'WeFooter',
  components: { UploadWithCrop },
  props: {
    value: {
      type: Object,
      default() {
        return {
          tabBarNameCheckedColour: null,
          tabBarNameUncheckedColour: null,
          tabBarCustoms: [
            { tabBarId: 1, tabBarName: '首页', checkedImage: [], uncheckedImage: [] },
            { tabBarId: 2, tabBarName: '商城', checkedImage: [], uncheckedImage: [] },
            { tabBarId: 3, tabBarName: '购物车', checkedImage: [], uncheckedImage: [] },
            { tabBarId: 4, tabBarName: '我的', checkedImage: [], uncheckedImage: [] }
          ],
          visible: false
        }
      }
    }
  },
  data() {
    return {
      activeName: '0',
      rules: {
        tabBarNameCheckedColour: [
          { required: true, message: '请选择标题选中颜色', trigger: 'blur' }
        ],
        tabBarNameUncheckedColour: [
          { required: true, message: '请选择标题未选中颜色', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    form: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(v => {
          if (v) {
            resolve()
          } else {
            reject(new Error(JSON.stringify({ pop: 'tabBar' })))
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus">
.settings {
  // display: flex;
  // flex-direction: column;
}

.settings .el-card__header {
  padding: 10px 20px;
}

.settings .el-card__body {
  padding: 10px;
}

.settings .settings-header {
  font-size: 16px;
  font-weight: 600;
}
</style>
